import React from 'react'
import { Sidebar } from '../../components/Sidebar/Sidebar'
import { Link, useParams } from 'react-router-dom'
import axios from 'axios'
import { Baseurl } from '../../../Config/Baseurl'
import { useEffect } from 'react'
import { useState } from 'react'
import moment from 'moment'

export const ExamHistory = () => {
  const params = useParams()

  // store the fetched details
  const [data, setData] = useState([])

  // fetch given exam details of the particular student/candidate
  const getdata = async () => {
    await axios
      .post(Baseurl.nodeLocal + 'result/fetchCandidateResult', {
        stud_id: params.id,
        exam_id: params.examid,
      })
      .then((res) => {
        setData(res.data.data[0])
      })
      .catch((err) => {})
  }

  useEffect(() => {
    getdata()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  var d = moment.duration(data.time_taken, 'milliseconds')
  var hours = Math.floor(d.asHours())
  var mins = Math.floor(d.asMinutes()) - hours * 60

  return (
    <div className="row">
      <div className="col-md-2">
        <Sidebar />
      </div>
      <div className="col-md-10 mt-4 p-3 d-flex align-items-center justify-content-center flex-column">
        <div className="d-flex justify-contetn-center">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/examdashboard" className="link text-primary">
                  Home
                </Link>
              </li>

              <li className="breadcrumb-item" aria-current="page">
                Exam History
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Honey Joshi
              </li>
            </ol>
          </nav>
        </div>
        <div className="card p-4 w-75">
          <div className="col-md-12">
            <div className="card-block w-100">
              <h6 className="m-b-20 p-b-5 b-b-default f-w-600">
                Candidate Details
              </h6>
              <div className="row">
                <div className="col-sm-6 mb-3">
                  <p className="m-b-10 f-w-600">Name</p>
                  <h6 className="text-muted f-w-400">{data.name}</h6>
                </div>
                <div className="col-sm-6">
                  <p className="m-b-10 f-w-600">Email</p>
                  <h6 className="text-muted f-w-400">{data.email}</h6>
                </div>
                <div className="col-sm-6">
                  <p className="m-b-10 f-w-600">Contact</p>
                  <h6 className="text-muted f-w-400">{data.contact}</h6>
                </div>
                <div className="col-sm-6 mb-3">
                  <p className="m-b-10 f-w-600">College</p>
                  <h6 className="text-muted f-w-400">{data.institute}</h6>
                </div>
                <div className="col-sm-6 mb-3">
                  <p className="m-b-10 f-w-600">Enrollment</p>
                  <h6 className="text-muted f-w-400">{data.enrollment}</h6>
                </div>

                <div className="col-sm-6 mb-3">
                  <p className="m-b-10 f-w-600">Applied Designation</p>
                  <h6 className="text-muted f-w-400">{data.applied_for}</h6>
                </div>
                <div className="col-sm-6 mb-3">
                  <p className="m-b-10 f-w-600">Applied Date</p>
                  <h6 className="text-muted f-w-400">{data.applied_date}</h6>
                </div>

                <div className="col-sm-6">
                  <p className="m-b-10 f-w-600">Given Exam</p>
                  <h6 className="text-muted f-w-400">{data.exam_name}</h6>
                </div>
                <h6 className="m-b-20 p-b-5 b-b-default f-w-600">
                  Exam Details
                </h6>

                <div className="col-sm-6 mb-3">
                  <p className="m-b-10 f-w-600">Exam Given Date</p>
                  <h6 className="text-muted f-w-400">{data.exam_given_date}</h6>
                </div>
                <div className="col-sm-6 mb-3">
                  <p className="m-b-10 f-w-600">Total Time Taken</p>
                  <h6 className="text-muted f-w-400">
                    {hours
                      ? (hours = 1
                          ? (hours, ' ', 'hour')
                          : hours > 1
                          ? (hours, ' ', 'hours')
                          : '')
                      : ''}
                    {mins} minutes
                  </h6>
                </div>
                <div className="col-sm-6">
                  <p className="m-b-10 f-w-600">Score out of</p>
                  <h6 className="text-muted f-w-400">
                    {data.correct_ans}/{data.total_que}
                  </h6>
                </div>
                <div className="col-sm-6 mb-3">
                  <p className="m-b-10 f-w-600">Exam Status</p>
                  <h6 className="text-muted f-w-400">{data.status_pf}</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
